import React from 'react';
import { useController, useFormContext } from 'react-hook-form';

import { StandardTextFieldProps, TextField as TextFieldMui } from '@mui/material';

export const TextField = ({ name, size = "small", required, ...muiRest }: Props) => {
  const { control } = useFormContext();
  const { field, fieldState } = useController({ name, control, rules: { required } });
  const { error } = fieldState;

  return <TextFieldMui size={size} required={required} error={!!error} {...field} {...muiRest} />;
};

interface Props extends StandardTextFieldProps {}
